import React from 'react'

const SvgPlateFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18.85 10.2a3.576 3.576 0 01-.981-.68C17.17 8.862 16.6 7.914 16.6 7.05c0-.606.098-1.337.331-2.011 1.93.877 3.46 2.253 4.316 3.91a4.792 4.792 0 01-.57.62c-.299.275-.62.494-.927.631L20 15l.055 1.741c-.447.486-.962.93-1.533 1.323l.328-7.864z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.805 11.248l-.33 7.908C15.13 19.696 13.61 20 12 20c-5.523 0-10-3.582-10-8s4.477-8 10-8c1.061 0 2.084.132 3.043.377A8.362 8.362 0 0014.6 7.05c0 1.678 1.043 3.147 1.973 3.997.075.068.152.135.232.201zM6.5 12c0-.885.538-1.748 1.535-2.412C9.028 8.926 10.428 8.5 12 8.5a.5.5 0 000-1c-1.742 0-3.341.47-4.52 1.256C6.305 9.539 5.5 10.676 5.5 12c0 1.324.805 2.461 1.98 3.245C8.659 16.03 10.258 16.5 12 16.5c.74 0 1.45-.084 2.115-.24a.5.5 0 00-.23-.974A8.236 8.236 0 0112 15.5c-1.572 0-2.972-.426-3.965-1.088C7.038 13.748 6.5 12.885 6.5 12z'
    />
    <path d='M19.75 10.2l.413 9.9a.863.863 0 11-1.725 0l.412-9.9a3.576 3.576 0 01-.928-.63C17.2 8.91 16.6 7.936 16.6 7.05c0-1.59.675-4.05 2.7-4.05C21.325 3 22 5.46 22 7.05c0 .886-.6 1.86-1.322 2.52-.3.274-.62.493-.928.63z' />
  </svg>
)

export default SvgPlateFilled
